'use strict';

require('classlist-polyfill');

require('element-closest');
//# sourceMappingURL=compatibility.js.map
